; (function() {

	document.addEventSelectorListener("click", "form [data-pixel='addToCart']", function(event, target) {
		const form = target.closest("form");
		const formData = new FormData(form);

		const productId = formData.get("product_variant_id");
		const quantity = parseInt(formData.get("quantity")) || 1;
		const price = parseFloat(target.getAttribute("data-price")) || 0;

		fbq("track", "AddToCart", {
			content_ids: [productId],
			content_type: "product",
			value: price * quantity,
			currency: "CZK"
		});
	});

}());
